import { render, staticRenderFns } from "./ListaIndicacoes.vue?vue&type=template&id=6d959d9d"
import script from "./ListaIndicacoes.vue?vue&type=script&lang=js"
export * from "./ListaIndicacoes.vue?vue&type=script&lang=js"
import style0 from "./ListaIndicacoes.vue?vue&type=style&index=0&id=6d959d9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports